var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alert',{ref:"alert",attrs:{"content":_vm.content,"type":_vm.type}}),_c('h1',[_vm._v("Redirecting")]),_c('h5',{staticClass:"red"},[_vm._v("to "+_vm._s(_vm.$route.params.groupId))]),_c('v-btn',{staticClass:"text-decoration-none",attrs:{"to":"/","color":"primary"}},[_vm._v("Go to main page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }